webpackJsonp([1],{

/***/ "/Awa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"nav":"SImqdi9gR-cDhGoQ8cKXh_0"};

/***/ }),

/***/ "2sGt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"_2Y337xqTSVVvR39KD8MH-b_1","block":"_3Ihk8HElNEgovuzuzYj9lb_1","note":"_3h6Wt1q89Qgx9XW-o8e1zk_1"};

/***/ }),

/***/ "3JRb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "53YY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"block":"_3STBeirk0Kh0ZeJnevStMn_0","listItem":"_18RTrTMJ2j-flqlkPrHTHU_0","icon":"_1qwgW4ouegxubh7_pPIl86_0","iconNoBg":"_1A9gw5kmYn30Q23U3x54aH_0","text":"_1sSsY7GnAPiofUCekQHBRQ_0","timestamp":"_1HuSNC8k7P4Wvn4H-62n29_0","projectName":"dwWZwgg7x-FqE23Ajkq9f_0","underline":"_1D1hakdnzv10_TekQO9DyA_0","title":"_37U19bOgjx0tXap6FnXZA5_0","desc":"B-g1FCqv2dPiQvP8IAs5V_0"};

/***/ }),

/***/ "7/Ux":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KRS5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"auth":"_2QtW3MZM1fR4G1UsmQHx7C_0"};

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vuex-persistedstate/dist/vuex-persistedstate.es.js + 2 modules
var vuex_persistedstate_es = __webpack_require__("424j");

// CONCATENATED MODULE: ./src/constants.js
/* harmony default export */ var constants = ({
  // AUTH
  SIGN_IN: 'SIGN_IN',
  SIGN_OUT: 'SIGN_OUT',
  SAVE_ID_TOKEN: 'SAVE_ID_TOKEN',

  // TRAINING
  SET_LESSONS: 'SET_LESSONS',
  SET_LESSONS_SRC: 'SET_LESSONS_SRC',
  NEW_LESSON: 'NEW_LESSON'
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/Header/Nav/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Nav = ({
  name: 'Nav',
  methods: {
    signOut: function signOut() {
      console.log('signout');
      this.$store.commit(constants.SIGN_OUT);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-741d5b2d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/Header/Nav/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.nav},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Overview")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/users"}},[_vm._v("Users")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/training"}},[_vm._v("Training")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/promos"}},[_vm._v("Promos")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/pixel-test"}},[_vm._v("Pixel Test")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/team-dashboard"}},[_vm._v("Team Dashboard")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/count"}},[_vm._v("Customer Button")]),_vm._v(" "),_c('a',{attrs:{"href":""},on:{"click":function($event){_vm.signOut()}}},[_vm._v("Logout")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var Header_Nav = (esExports);
// CONCATENATED MODULE: ./src/components/lib/Header/Nav/index.vue
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("/Awa")
  __webpack_require__("ojnS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Nav,
  Header_Nav,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var lib_Header_Nav = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/Header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Header = ({
  name: 'Header',
  components: {
    Nav: lib_Header_Nav
  },
  props: ['nav', 'center']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c645801","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/Header/index.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.header},[_c('div',{class:_vm.$style.darkBackground}),_vm._v(" "),_c('div',{class:_vm.$style.main},[_c('div',{class:_vm.$style.brand},[_c('h1',[_vm._v("Proof Admin")])]),_vm._v(" "),(!_vm.nav)?_c('Nav'):_vm._e()],1)])}
var Header_staticRenderFns = []
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var lib_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/components/lib/Header/index.vue
function Header_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("fDhm")
}
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = Header_injectStyle
/* scopeId */
var Header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  Header,
  lib_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var components_lib_Header = (Header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login/index.vue
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Login = ({
  name: 'Login',
  components: {
    Header: components_lib_Header
  },
  methods: {
    signIn: function signIn() {
      auth.signInWithGoogle();
    }
  },
  computed: {
    signInFail: function signInFail() {
      return this.$store.state.signInFail;
    }
  },
  watch: {
    signInFail: function signInFail() {
      if (this.$store.state.signInFail) {
        this.$toasted.show('Login failed: ' + this.$store.state.signInFail, {
          duration: 3000,
          className: 'toasty-error'
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7569cf94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/index.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.login}},[_c('Header',{attrs:{"nav":"false","center":"false"}}),_vm._v(" "),_c('div',{class:_vm.$style.auth},[_c('h2',[_vm._v("Please Login")]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":_vm.signIn}},[_vm._v("Continue With Google")])])],1)}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var components_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/Login/index.vue
function Login_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("KRS5")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  components_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var src_components_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var lodash_orderBy = __webpack_require__("Ba3q");
var orderBy_default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy);

// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__("2247");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// CONCATENATED MODULE: ./src/database/index.js


var firebase = window.firebase;

function openConnection() {
  // Initialize Firebase
  var config = {
    apiKey: 'AIzaSyCjBAQXKM5A96GQ7PTxTeoP29uzjBb_1Ek',
    authDomain: 'proof-dev.firebaseapp.com',
    databaseURL: 'https://proof-dev.firebaseio.com',
    projectId: 'proof-dev',
    storageBucket: 'proof-dev.appspot.com',
    messagingSenderId: '728057737992'
  };
  firebase.initializeApp(config);
}

/**
 * Return data from the specified firebase path
 * @param {array|string} path
 * @param {string} orderBy what property do you want to order by
 * @returns {promise}
 */
function get(path, orderBy) {
  var ref = path.join('/');
  return firebase.database().ref(ref).once('value').then(function (snapshot) {
    var formatted = map_default()(snapshot.val(), function (v, k) {
      v['id'] = k;
      return v;
    });
    if (orderBy) {
      return orderBy_default()(formatted, orderBy);
    } else {
      return formatted;
    }
  });
}

/**
 * Retrieve a single item from the firebase path
 * @param {array|string} path
 * @returns {promise}
 */
function getSingle(path) {
  var ref = path.join('/');
  return firebase.database().ref(ref).once('value').then(function (snapshot) {
    var data = snapshot.val();
    if (data) {
      data.id = path[path.length - 1];
      return data;
    }
  });
}

function getWhile(path, field, value) {
  var ref = path.join('/');
  return firebase.database().ref(ref).orderByChild(field).equalTo(value).once('value').then(function (snapshot) {
    var formatted = map_default()(snapshot.val(), function (v, k) {
      v['id'] = k;
      return v;
    });
    return formatted;
  });
}

function update(path, data) {
  var ref = path.join('/');
  return firebase.database().ref(ref).update(data);
}

function database_set(path, data) {
  var ref = path.join('/');
  return firebase.database().ref(ref).set(data);
}

function bindOrder(path, order, limit, cb) {
  var ref = path.join('/');
  firebase.database().ref(ref).orderByChild(order).limitToLast(limit).on('value', cb);
}

/* harmony default export */ var database = ({
  openConnection: openConnection,
  get: get,
  getSingle: getSingle,
  getWhile: getWhile,
  update: update,
  set: database_set,
  bindOrder: bindOrder
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Overview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Overview = ({
  name: 'Overview',
  components: {
    Header: components_lib_Header
  },
  data: function data() {
    return {
      loading: false,
      userList: {}
    };
  },

  methods: {
    loadAutoUpgrade: function loadAutoUpgrade() {
      var _this = this;

      this.loading = true;
      database.getWhile(['accounts'], 'disableAutoUpgrade', true).then(function (data) {
        _this.userList = data;
        _this.loading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d340966","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overview/index.vue
var Overview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.overview}},[_c('Header'),_vm._v(" "),_c('h1',[_vm._v("Overview")]),_vm._v(" "),_c('div',{class:_vm.$style.body},[_c('div',{class:[_vm.$style.block]},[_c('h2',[_vm._v("Auto upgrade disabled")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.loadAutoUpgrade()}}},[_vm._v("Load list")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_vm._v("Loading...")]),_vm._v(" "),_vm._l((_vm.userList),function(user){return _c('div',[_c('router-link',{attrs:{"to":/users/ + user.id}},[_vm._v(_vm._s(user.email))])],1)})],2)])],1)}
var Overview_staticRenderFns = []
var Overview_esExports = { render: Overview_render, staticRenderFns: Overview_staticRenderFns }
/* harmony default export */ var components_Overview = (Overview_esExports);
// CONCATENATED MODULE: ./src/components/Overview/index.vue
function Overview_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("XotS")
}
var Overview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Overview___vue_template_functional__ = false
/* styles */
var Overview___vue_styles__ = Overview_injectStyle
/* scopeId */
var Overview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Overview___vue_module_identifier__ = null
var Overview_Component = Overview_normalizeComponent(
  Overview,
  components_Overview,
  Overview___vue_template_functional__,
  Overview___vue_styles__,
  Overview___vue_scopeId__,
  Overview___vue_module_identifier__
)

/* harmony default export */ var src_components_Overview = (Overview_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/api/config.js
/* harmony default export */ var config = ({
  API_BASE_URL: 'https://proof-app-api-v1-staging.herokuapp.com',
  ALGOLIA_ACCOUNT_INDEX: 'staging_accounts'
});
// CONCATENATED MODULE: ./src/api/algolia.js




/**
 * Retrieve the Algolia API key
 * @returns {promise}
 */
function getKey() {
  return auth.getAuthToken().then(function (token) {
    return axios_default.a.get(config.API_BASE_URL + '/admin/algolia/key', {
      params: {
        authToken: token
      }
    }).then(function (res) {
      return res.data.key;
    });
  });
}

/**
 * Refresh the Algolia account index
 * @returns {promise}
 */
function algolia_reindex() {
  return auth.getAuthToken().then(function (token) {
    return axios_default.a.post(config.API_BASE_URL + '/admin/algolia/reindex', {
      authToken: token
    }).then(function (res) {
      return res.data.key;
    });
  });
}

/* harmony default export */ var algolia = ({
  getKey: getKey,
  reindex: algolia_reindex
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Users/list/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Users_list = ({
  name: 'users',
  data: function data() {
    return {
      query: '',
      algoliaKey: '',
      algoliaIndex: config.ALGOLIA_ACCOUNT_INDEX
    };
  },

  methods: {
    selectItem: function selectItem(id) {
      this.$router.push({ path: '/users/' + id });
    },
    reindex: function reindex() {
      var _this = this;

      if (confirm('Reindex user accounts?')) {
        algolia.reindex().then(function () {
          _this.$toasted.show('Accounts have been sucessfully reindexed', {
            duration: 3000,
            className: 'toasty'
          });
        }).catch(function (err) {
          console.log('Reindex error:', err);
          _this.$toasted.show('Error: unable to reindex accounts', {
            duration: 3000,
            className: 'toasty-error'
          });
        });
      }
    }
  },
  mounted: function mounted() {
    var vc = this;
    algolia.getKey().then(function (data) {
      vc.algoliaKey = data;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a23462","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/list/index.vue
var list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.algoliaKey)?_c('div',{class:_vm.$style.list},[_c('p',[_c('button',{on:{"click":_vm.reindex}},[_vm._v("Reindex accounts")])]),_vm._v(" "),_c('ais-index',{attrs:{"app-id":"HHG05IP3IE","api-key":_vm.algoliaKey,"index-name":_vm.algoliaIndex}},[_c('ais-search-box'),_vm._v(" "),_c('ul',[_c('ais-results',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var result = ref.result;
return [_c('li',{on:{"click":function($event){_vm.selectItem(result.objectID)}}},[_vm._v(_vm._s(result.email))])]}}])})],1)],1)],1):_vm._e()}
var list_staticRenderFns = []
var list_esExports = { render: list_render, staticRenderFns: list_staticRenderFns }
/* harmony default export */ var components_Users_list = (list_esExports);
// CONCATENATED MODULE: ./src/components/Users/list/index.vue
function list_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("ODsN")
}
var list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var list___vue_template_functional__ = false
/* styles */
var list___vue_styles__ = list_injectStyle
/* scopeId */
var list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var list___vue_module_identifier__ = null
var list_Component = list_normalizeComponent(
  Users_list,
  components_Users_list,
  list___vue_template_functional__,
  list___vue_styles__,
  list___vue_scopeId__,
  list___vue_module_identifier__
)

/* harmony default export */ var src_components_Users_list = (list_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/parse-float.js
var parse_float = __webpack_require__("5dBV");
var parse_float_default = /*#__PURE__*/__webpack_require__.n(parse_float);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__("kbi+");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/lodash/remove.js
var remove = __webpack_require__("afSG");
var remove_default = /*#__PURE__*/__webpack_require__.n(remove);

// EXTERNAL MODULE: ./node_modules/q/q.js
var q = __webpack_require__("/Luh");
var q_default = /*#__PURE__*/__webpack_require__.n(q);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/Form/Input/index.vue
//
//
//
//
//
//

/* harmony default export */ var Input = ({
  name: 'Input',
  props: ['value'],
  methods: {
    updateField: function updateField(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35ae37f9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/Form/Input/index.vue
var Input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{class:_vm.$style.input,attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){_vm.updateField($event.target.value)}}})])}
var Input_staticRenderFns = []
var Input_esExports = { render: Input_render, staticRenderFns: Input_staticRenderFns }
/* harmony default export */ var Form_Input = (Input_esExports);
// CONCATENATED MODULE: ./src/components/lib/Form/Input/index.vue
function Input_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("wzrY")
}
var Input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Input___vue_template_functional__ = false
/* styles */
var Input___vue_styles__ = Input_injectStyle
/* scopeId */
var Input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Input___vue_module_identifier__ = null
var Input_Component = Input_normalizeComponent(
  Input,
  Form_Input,
  Input___vue_template_functional__,
  Input___vue_styles__,
  Input___vue_scopeId__,
  Input___vue_module_identifier__
)

/* harmony default export */ var lib_Form_Input = (Input_Component.exports);

// CONCATENATED MODULE: ./src/api/account.js


var account_firebase = window.firebase;

/**
 * Add promo code to an account
 * @param {string} promo valid promo code
 * @returns {promise}
 */
function account_addPromo(accountId, promo) {
  return account_firebase.auth().currentUser.getIdToken().then(function (token) {
    return axios_default.a.post(config.API_BASE_URL + '/admin/promo', {
      authToken: token,
      accountId: accountId,
      promo: promo
    });
  });
}

/**
 * Retrieve a pixel configuration
 * @param {string} pixelId
 */
function getPixel(pixelId) {
  return account_firebase.auth().currentUser.getIdToken().then(function (authToken) {
    return axios_default.a.get(config.API_BASE_URL + '/admin/pixel', {
      params: {
        pixelId: pixelId,
        authToken: authToken
      }
    }).then(function (res) {
      return res.data;
    });
  });
}

/**
 * Update a pixel configuration
 * @param {string} pixelId
 * @param {object} data
 */
function updatePixel(pixelId, data) {
  return account_firebase.auth().currentUser.getIdToken().then(function (authToken) {
    return axios_default.a.patch(config.API_BASE_URL + '/admin/pixel', {
      pixelId: pixelId,
      authToken: authToken,
      config: data
    });
  });
}

/* harmony default export */ var account = ({
  addPromo: account_addPromo,
  getPixel: getPixel,
  updatePixel: updatePixel
});
// CONCATENATED MODULE: ./src/api/campaign.js


var campaign_firebase = window.firebase;

/**
 * Retrieve a campaign configuration
 * @param {string} pixelId
 */
function campaign_list(pixelId) {
  return campaign_firebase.auth().currentUser.getIdToken().then(function (authToken) {
    return axios_default.a.get(config.API_BASE_URL + '/admin/campaign', {
      params: {
        pixelId: pixelId,
        authToken: authToken
      }
    }).then(function (res) {
      return res.data;
    });
  });
}

/**
 * Update a pixel configuration
 * @param {string} pixelId
 * @param {string} campaignid
 * @param {object} data
 */
function campaign_update(pixelId, campaignId, data) {
  return campaign_firebase.auth().currentUser.getIdToken().then(function (authToken) {
    return axios_default.a.patch(config.API_BASE_URL + '/admin/campaign', {
      pixelId: pixelId,
      campaignId: campaignId,
      authToken: authToken,
      config: data
    });
  });
}

/* harmony default export */ var campaign = ({
  list: campaign_list,
  update: campaign_update
});
// CONCATENATED MODULE: ./src/api/billing.js




var billing_firebase = window.firebase;

/**
 * Get a list of available plans
 * @returns {promise}
 */
function listPlans() {
  return auth.getAuthToken().then(function (token) {
    return axios_default.a.get(config.API_BASE_URL + '/admin/subscription/plans', {
      params: { authToken: token }
    }).then(function (res) {
      return res.data;
    });
  });
}

/**
 * Change an account's plan
 * @param {string} subscriptionId a valid Stripe subscriptionId
 * @param {string} planId a valid Stripe planId
 * @param {boolean} charge whether to charge the plan immediately
 * @param {boolean} retainTrial keep trial if one exists
 */
function changePlan(subscriptionId, planId, charge, retainTrial) {
  return auth.getAuthToken().then(function (token) {
    return axios_default.a.post(config.API_BASE_URL + '/admin/subscription/changePlan', {
      authToken: token,
      subscription: subscriptionId,
      plan: planId,
      charge: charge,
      retainTrial: retainTrial
    }).then(function (res) {
      return res.data;
    });
  });
}

/**
 * Pause a user's account
 * @param {string} accountId
 * @returns {promise}
 */
function pause(accountId) {
  return billing_firebase.auth().currentUser.getIdToken().then(function (token) {
    return axios_default.a.post(config.API_BASE_URL + '/admin/subscription/pause', {
      authToken: token,
      accountId: accountId
    }).catch(function (res) {
      return promise_default.a.reject(res.response.data.error);
    });
  });
}

/**
 * Unpause a user's account
 * @param {string} accountId
 * @returns {promise}
 */
function unpause(accountId) {
  return billing_firebase.auth().currentUser.getIdToken().then(function (token) {
    return axios_default.a.post(config.API_BASE_URL + '/admin/subscription/unpause', {
      authToken: token,
      accountId: accountId
    }).catch(function (res) {
      return promise_default.a.reject(res.response.data.error);
    });
  });
}

/* harmony default export */ var billing = ({
  listPlans: listPlans,
  changePlan: changePlan,
  pause: pause,
  unpause: unpause
});
// CONCATENATED MODULE: ./src/components/Users/edit/edit.js
// editable account fields
var ACCOUNT_FIELDS = ['active', 'customer_id', 'disableAutoUpgrade', 'planId', 'resetOnPlanChange', 'subscriptionId', 'visitorLimitModifier', 'visitorLimitModifierType'];

// editable pixel fields
var PIXEL_FIELDS = ['active', 'debug', 'init', 'rb', 'spaCompatibility'];

/**
 * Build update object based on provided params
 * * @param {array} props list of allowed properties
 * @param {object} data source data object
 * @returns {object}
 */
function createUpdateObject(props, data) {
  var obj = {};
  for (var i in props) {
    var prop = props[i];
    if (data.hasOwnProperty(prop)) {
      obj[prop] = data[prop];
    }
  }
  return obj;
}

/* harmony default export */ var edit = ({
  ACCOUNT_FIELDS: ACCOUNT_FIELDS,
  PIXEL_FIELDS: PIXEL_FIELDS,
  createUpdateObject: createUpdateObject
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Users/edit/index.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var Users_edit = ({
  name: 'edit',
  components: {
    uiInput: lib_Form_Input
  },
  data: function data() {
    return {
      saving: false,
      selected: {},
      pixel: {},
      campaigns: {},
      onboardingState: null,
      loading: false,
      allPlans: [],
      allPromos: [],
      newPromo: null,
      addedPromos: [],
      initialPlan: '',
      retainTrial: true,
      chargeImmediately: true
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      if (this.selected.id) {
        this.saving = true;
        var updateObj = edit.createUpdateObject(edit.ACCOUNT_FIELDS, this.selected);
        var promiseList = [];
        promiseList.push(database.update(['accounts', this.selected.id], updateObj));

        // update plan
        if (this.selected.subscriptionId && this.planChanged) {
          this.initialPlan = this.selected.planId;
          promiseList.push(billing.changePlan(this.selected.subscriptionId, this.selected.planId, this.chargeImmediately, this.retainTrial));
        }

        // update pixel
        var pixelObj = edit.createUpdateObject(edit.PIXEL_FIELDS, this.pixel);
        promiseList.push(account.updatePixel(this.selected.id, pixelObj));

        // update watchDOM
        for (var cid in this.campaigns) {
          var wd = this.campaigns[cid].watchDOM ? true : null;
          promiseList.push(campaign.update(this.selected.id, this.campaigns[cid].campaignId, { watchDOM: wd }));
        }

        // update account index
        if (this.selected.customer_id) {
          promiseList.push(database.set(['account_index', this.selected.customer_id], this.selected.id));
        }

        // update onboarding state
        promiseList.push(database.update(['onboarding', this.selected.id], { state: this.onboardingState }));

        // add all promos to the user's account
        for (var promo in this.addedPromos) {
          promiseList.push(account.addPromo(this.selected.id, this.addedPromos[promo]));
        }

        q_default.a.all(promiseList).then(function () {
          _this.$toasted.show('Changes were Saved', {
            duration: 3000,
            className: 'toasty'
          });
        }).catch(function (err) {
          console.log('Save error: ', err);
          _this.$toasted.show('Error: Some settings did not save', {
            duration: 3000,
            className: 'toasty-error'
          });
        }).finally(function () {
          _this.saving = false;
        });
      } else {
        this.$toasted.show('Nothing to save. Select an email first', {
          duration: 3000,
          className: 'toasty-error'
        });
      }
    },
    loadAccount: function loadAccount(accountId) {
      var _this2 = this;

      this.loading = true;
      // get account
      database.getSingle(['accounts', accountId]).then(function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(accountData) {
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!accountData) {
                    _context.next = 12;
                    break;
                  }

                  _this2.selected = accountData;
                  _this2.initialPlan = accountData.planId;
                  _context.next = 5;
                  return account.getPixel(accountId);

                case 5:
                  _this2.pixel = _context.sent;
                  _context.next = 8;
                  return campaign.list(accountId);

                case 8:
                  _this2.campaigns = _context.sent;

                  // get onboarding
                  database.getSingle(['onboarding', accountId]).then(function (obData) {
                    if (obData) {
                      _this2.onboardingState = obData.state;
                    }
                  });
                  _context.next = 13;
                  break;

                case 12:
                  return _context.abrupt('return', promise_default.a.reject(new Error('Account does not exist')));

                case 13:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        console.log('Load error: ', err);
        _this2.$toasted.show('Unable to load account', {
          duration: 3000,
          className: 'toasty-error'
        });
      }).finally(function () {
        _this2.loading = false;
      });
    },
    addPromo: function addPromo() {
      if (this.newPromo) {
        // New promos added
        this.addedPromos.push(this.newPromo);
        // Update list of promos for this account
        if (!this.selected.promos) {
          var promos = {};
          promos[this.newPromo] = true;
          vue_esm["a" /* default */].set(this.selected, 'promos', promos);
        } else {
          vue_esm["a" /* default */].set(this.selected.promos, this.newPromo, true);
        }
      }
    },
    resetTraffic: function resetTraffic() {
      var _this3 = this;

      if (confirm("Reset this user's traffic?")) {
        this.saving = true;
        // reset user's traffic
        database.set(['account_stats', this.selected.id], null).then(function () {
          _this3.$toasted.show('User\'s traffic was reset', {
            duration: 3000,
            className: 'toasty'
          });
          _this3.saving = false;
        }).catch(function () {
          _this3.saving = false;
        });
      }
    },
    updateModifiers: function updateModifiers() {
      // remove modifier values if type is not set
      if (!this.selected.visitorLimitModifierType) {
        this.selected.visitorLimitModifierType = null;
        this.selected.visitorLimitModifier = null;
        this.selected.resetOnPlanChange = null;
      }
    },
    togglePause: function togglePause() {
      var _this4 = this;

      if (confirm(this.pauseAction + '?')) {
        this.saving = true;
        var pauseFunction = this.pixel.paused ? billing.unpause : billing.pause;
        pauseFunction(this.selected.id).then(function () {
          _this4.pixel.paused = !_this4.pixel.paused;
          _this4.$toasted.show(_this4.pauseAction + ' successful', {
            duration: 3000,
            className: 'toasty'
          });
          _this4.saving = false;
        }).catch(function (err) {
          _this4.$toasted.show(_this4.pauseAction + ' unsuccessful: ' + err, {
            duration: 3000,
            className: 'toasty-error'
          });
          _this4.saving = false;
        });
      }
    }
  },
  computed: {
    planChanged: function planChanged() {
      // check if the plan has been changed
      return this.initialPlan !== this.selected.planId;
    },
    planUpgrade: function planUpgrade() {
      // determine whether the plan change is an upgrade
      var oldPlan = find_default()(this.allPlans, { id: this.initialPlan });
      var newPlan = find_default()(this.allPlans, { id: this.selected.planId });
      if (oldPlan && newPlan) {
        return newPlan.amount - oldPlan.amount > 0;
      }
    },
    pauseAction: function pauseAction() {
      return this.pixel.paused ? 'Unpause account' : 'Pause account';
    },

    visitorLimitModifier: {
      get: function get() {
        return this.selected.visitorLimitModifier;
      },
      set: function set(val) {
        this.selected.visitorLimitModifier = parse_float_default()(val);
      }
    }
  },
  watch: {
    $route: function $route(to, from) {
      // load account when selected from list
      if (to.params.id) {
        this.loadAccount(to.params.id);
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    // get the list of available promo codes
    database.getSingle(['promos']).then(function (list) {
      _this5.allPromos = keys_default()(list);
    });
    // get the list of available plans
    billing.listPlans().then(function (plans) {
      // planID from account should never be 'paused'
      remove_default()(plans, { id: 'paused' });
      _this5.allPlans = plans;
    });
    // load account if visiting URL directly
    if (this.$route.params.id) {
      this.loadAccount(this.$route.params.id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58c5aafe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/edit/index.vue
var edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!this.$route.params.id)?_c('div',[_vm._v("Select a user to edit")]):(_vm.loading)?_c('h2',[_vm._v("Loading...")]):_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.save($event)}}},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.selected.fullName))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.selected.email)+" "),(_vm.pixel.paused)?_c('span',[_vm._v("(Paused)")]):_vm._e()]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("Account Active")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.active),expression:"selected.active"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selected.active)?_vm._i(_vm.selected.active,null)>-1:(_vm.selected.active)},on:{"change":function($event){var $$a=_vm.selected.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected.active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected.active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.selected, "active", $$c)}}}})]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("Pixel Active")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pixel.active),expression:"pixel.active"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.pixel.active)?_vm._i(_vm.pixel.active,null)>-1:(_vm.pixel.active)},on:{"change":function($event){var $$a=_vm.pixel.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pixel.active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pixel.active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.pixel, "active", $$c)}}}})]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("Debug logging")]),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pixel.debug),expression:"pixel.debug"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pixel, "debug", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Off")]),_vm._v(" "),_c('option',{attrs:{"value":"support"}},[_vm._v("Clean")]),_vm._v(" "),_c('option',{attrs:{"value":"admin"}},[_vm._v("Full")])])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("Remove Branding")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pixel.rb),expression:"pixel.rb"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.pixel.rb)?_vm._i(_vm.pixel.rb,null)>-1:(_vm.pixel.rb)},on:{"change":function($event){var $$a=_vm.pixel.rb,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pixel.rb=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pixel.rb=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.pixel, "rb", $$c)}}}})]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("WatchDOM")]),_vm._v(" "),(_vm.campaigns.length > 0)?_c('table',_vm._l((_vm.campaigns),function(campaign,cid){return _c('tr',[_c('td',[_vm._v(" - "),_c('code',[_vm._v(_vm._s(campaign.name))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(campaign.watchDOM),expression:"campaign.watchDOM"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(campaign.watchDOM)?_vm._i(campaign.watchDOM,null)>-1:(campaign.watchDOM)},on:{"change":function($event){var $$a=campaign.watchDOM,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(campaign.watchDOM=$$a.concat([$$v]))}else{$$i>-1&&(campaign.watchDOM=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(campaign, "watchDOM", $$c)}}}})])])})):_c('div',{class:_vm.$style.note},[_vm._v("-No campaigns created-")])]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("SPA Support")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pixel.spaCompatibility),expression:"pixel.spaCompatibility"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.pixel.spaCompatibility)?_vm._i(_vm.pixel.spaCompatibility,null)>-1:(_vm.pixel.spaCompatibility)},on:{"change":function($event){var $$a=_vm.pixel.spaCompatibility,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pixel.spaCompatibility=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pixel.spaCompatibility=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.pixel, "spaCompatibility", $$c)}}}})]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("Stripe Customer ID")]),_vm._v(" "),_c('ui-input',{model:{value:(_vm.selected.customer_id),callback:function ($$v) {_vm.$set(_vm.selected, "customer_id", $$v)},expression:"selected.customer_id"}}),_vm._v(" "),_c('label',[_vm._v("Stripe Subscription ID")]),_vm._v(" "),_c('ui-input',{model:{value:(_vm.selected.subscriptionId),callback:function ($$v) {_vm.$set(_vm.selected, "subscriptionId", $$v)},expression:"selected.subscriptionId"}})],1),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("Current Plan")]),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.planId),expression:"selected.planId"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected, "planId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.allPlans),function(plan){return _c('option',{domProps:{"value":plan.id}},[_vm._v(_vm._s(plan.name)+" ($"+_vm._s(plan.amount / 100)+")")])})),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.planChanged),expression:"planChanged"}],class:_vm.$style.warn},[_vm._v("*User's plan will change on save")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.planChanged),expression:"planChanged"}]},[_vm._v("\n          Retain the user's trial "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.retainTrial),expression:"retainTrial"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.retainTrial)?_vm._i(_vm.retainTrial,null)>-1:(_vm.retainTrial)},on:{"change":function($event){var $$a=_vm.retainTrial,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.retainTrial=$$a.concat([$$v]))}else{$$i>-1&&(_vm.retainTrial=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.retainTrial=$$c}}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.planUpgrade),expression:"planUpgrade"}]},[_vm._v("\n            Charge immediately "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chargeImmediately),expression:"chargeImmediately"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.chargeImmediately)?_vm._i(_vm.chargeImmediately,null)>-1:(_vm.chargeImmediately)},on:{"change":function($event){var $$a=_vm.chargeImmediately,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.chargeImmediately=$$a.concat([$$v]))}else{$$i>-1&&(_vm.chargeImmediately=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.chargeImmediately=$$c}}}})])])]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("Disable Auto Upgrade")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.disableAutoUpgrade),expression:"selected.disableAutoUpgrade"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selected.disableAutoUpgrade)?_vm._i(_vm.selected.disableAutoUpgrade,null)>-1:(_vm.selected.disableAutoUpgrade)},on:{"change":function($event){var $$a=_vm.selected.disableAutoUpgrade,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected.disableAutoUpgrade=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected.disableAutoUpgrade=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.selected, "disableAutoUpgrade", $$c)}}}})]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("Visitor Override")]),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.visitorLimitModifierType),expression:"selected.visitorLimitModifierType"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected, "visitorLimitModifierType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateModifiers]}},[_c('option'),_vm._v(" "),_c('option',{attrs:{"value":"limit"}},[_vm._v("limit")]),_vm._v(" "),_c('option',{attrs:{"value":"add"}},[_vm._v("add")]),_vm._v(" "),_c('option',{attrs:{"value":"multiply"}},[_vm._v("multiply")])])]),_vm._v(" "),(_vm.selected.visitorLimitModifierType)?_c('div',[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.visitorLimitModifier),expression:"visitorLimitModifier"}],attrs:{"type":"number","step":".01"},domProps:{"value":(_vm.visitorLimitModifier)},on:{"input":function($event){if($event.target.composing){ return; }_vm.visitorLimitModifier=$event.target.value}}})]),_vm._v(" "),_c('div',[_vm._v("\n            Reset on plan change "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.resetOnPlanChange),expression:"selected.resetOnPlanChange"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selected.resetOnPlanChange)?_vm._i(_vm.selected.resetOnPlanChange,null)>-1:(_vm.selected.resetOnPlanChange)},on:{"change":function($event){var $$a=_vm.selected.resetOnPlanChange,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected.resetOnPlanChange=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected.resetOnPlanChange=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.selected, "resetOnPlanChange", $$c)}}}})])]):_vm._e()]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("Onboarding State")]),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.onboardingState),expression:"onboardingState"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.onboardingState=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"plans"}},[_vm._v("Choose Plan")]),_vm._v(" "),_c('option',{attrs:{"value":"payment"}},[_vm._v("Payment Info")]),_vm._v(" "),_c('option',{attrs:{"value":"complete"}},[_vm._v("Complete")])])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('label',[_vm._v("Promos")]),_vm._v(" "),_c('ul',_vm._l((_vm.selected.promos),function(promo,name){return _c('li',[_vm._v(_vm._s(name))])})),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPromo),expression:"newPromo"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.newPromo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.allPromos),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])})),_vm._v(" "),(_vm.newPromo)?_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.addPromo()}}},[_vm._v("Add")]):_vm._e()])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{class:_vm.$style.section},[_c('button',{staticClass:"btn",attrs:{"disabled":_vm.saving,"type":"submit"}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"disabled":_vm.saving,"type":"button"},on:{"click":_vm.togglePause}},[_vm._v(_vm._s(_vm.pauseAction))]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"disabled":_vm.saving,"type":"button"},on:{"click":function($event){_vm.resetTraffic()}}},[_vm._v("Reset Traffic")])]),_vm._v(" "),(_vm.saving)?_c('div',[_vm._v("Saving...")]):_vm._e()])])}
var edit_staticRenderFns = []
var edit_esExports = { render: edit_render, staticRenderFns: edit_staticRenderFns }
/* harmony default export */ var components_Users_edit = (edit_esExports);
// CONCATENATED MODULE: ./src/components/Users/edit/index.vue
function edit_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("OGIF")
}
var edit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var edit___vue_template_functional__ = false
/* styles */
var edit___vue_styles__ = edit_injectStyle
/* scopeId */
var edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var edit___vue_module_identifier__ = null
var edit_Component = edit_normalizeComponent(
  Users_edit,
  components_Users_edit,
  edit___vue_template_functional__,
  edit___vue_styles__,
  edit___vue_scopeId__,
  edit___vue_module_identifier__
)

/* harmony default export */ var src_components_Users_edit = (edit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Users/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Users = ({
  name: 'Users',
  components: {
    Header: components_lib_Header,
    list: src_components_Users_list,
    edit: src_components_Users_edit
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4dc912a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/index.vue
var Users_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.users}},[_c('Header'),_vm._v(" "),_c('h1',[_vm._v("Users")]),_vm._v(" "),_c('div',{class:_vm.$style.body},[_c('div',{class:[_vm.$style.block]},[_c('h1',[_vm._v("Edit User")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('edit')],1),_vm._v(" "),_c('div',{class:[_vm.$style.block, _vm.$style.short]},[_c('list')],1)])],1)}
var Users_staticRenderFns = []
var Users_esExports = { render: Users_render, staticRenderFns: Users_staticRenderFns }
/* harmony default export */ var components_Users = (Users_esExports);
// CONCATENATED MODULE: ./src/components/Users/index.vue
function Users_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("msf9")
}
var Users_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Users___vue_template_functional__ = false
/* styles */
var Users___vue_styles__ = Users_injectStyle
/* scopeId */
var Users___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Users___vue_module_identifier__ = null
var Users_Component = Users_normalizeComponent(
  Users,
  components_Users,
  Users___vue_template_functional__,
  Users___vue_styles__,
  Users___vue_scopeId__,
  Users___vue_module_identifier__
)

/* harmony default export */ var src_components_Users = (Users_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/filter.js
var filter = __webpack_require__("RyI1");
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);

// EXTERNAL MODULE: ./node_modules/lodash/each.js
var each = __webpack_require__("9uKM");
var each_default = /*#__PURE__*/__webpack_require__.n(each);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Training/list/listItem/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var listItem = ({
  name: 'listItem',
  props: ['training'],
  data: function data() {
    return {
      showChildren: false
    };
  },

  methods: {
    selectItem: function selectItem(id) {
      this.$router.push({ path: '/training/' + id });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-feb5804c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Training/list/listItem/index.vue
var listItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[(_vm.training.lessons)?_c('span',{class:{plusMinus: true, showChildren: _vm.showChildren},on:{"click":function($event){_vm.showChildren = !_vm.showChildren}}},[_vm._v(" "+_vm._s(_vm.showChildren ? '-' : '+')+" ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"title",on:{"click":function($event){_vm.selectItem(_vm.training.id)}}},[_vm._v(_vm._s(_vm.training.title))]),_vm._v(" "),(_vm.training.lessons && _vm.showChildren)?_c('ul',_vm._l((_vm.training.lessons),function(item){return _c('list-item',{key:item.id,attrs:{"training":item}})})):_vm._e()])}
var listItem_staticRenderFns = []
var listItem_esExports = { render: listItem_render, staticRenderFns: listItem_staticRenderFns }
/* harmony default export */ var list_listItem = (listItem_esExports);
// CONCATENATED MODULE: ./src/components/Training/list/listItem/index.vue
function listItem_injectStyle (ssrContext) {
  __webpack_require__("3JRb")
}
var listItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var listItem___vue_template_functional__ = false
/* styles */
var listItem___vue_styles__ = listItem_injectStyle
/* scopeId */
var listItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var listItem___vue_module_identifier__ = null
var listItem_Component = listItem_normalizeComponent(
  listItem,
  list_listItem,
  listItem___vue_template_functional__,
  listItem___vue_styles__,
  listItem___vue_scopeId__,
  listItem___vue_module_identifier__
)

/* harmony default export */ var Training_list_listItem = (listItem_Component.exports);

// CONCATENATED MODULE: ./src/components/Training/list/lib/index.js



function lib_buildCatTree(data, cat) {
  var _this = this;

  return each_default()(filter_default()(data, { category: cat }), function (item) {
    if (item.type === 'category') {
      item.lessons = _this.buildCatTree(data, item.id);
    }

    return item;
  });
}

/* harmony default export */ var lib = ({
  buildCatTree: lib_buildCatTree
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Training/list/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Training_list = ({
  name: 'training',
  components: {
    listItem: Training_list_listItem
  },
  data: function data() {
    return {
      selected: {},
      loading: true,
      query: '',
      results: []
    };
  },

  computed: {
    srcData: function srcData() {
      return this.$store.state.training.lessonsSrc;
    },
    items: function items() {
      return this.$store.state.training.lessons;
    }
  },
  methods: {
    getLessons: function getLessons() {
      var vc = this;
      database.get(['academy', 'lessons'], ['type', 'index', 'category']).then(function (data) {
        vc.$store.commit(constants.SET_LESSONS_SRC, data);
        vc.$store.commit(constants.SET_LESSONS, vc.buildCatTree(data, 'academy'));
        vc.loading = false;
        vc.$toasted.show('Lessons have been loaded from the database', {
          duration: 3000,
          className: 'toasty'
        });
      });
    },
    search: function search(query) {
      this.results = filter_default()(this.srcData, function (n) {
        var props = [];
        each_default()(n, function (val, key) {
          if (typeof val === 'string' && val.includes(query)) {
            props.push(val);
          }
        });
        return props.length;
      });
    },
    buildCatTree: function buildCatTree(data, cat) {
      return lib.buildCatTree(data, cat);
    },
    selectItem: function selectItem(id) {
      this.$router.push({ path: '/training/' + id });
    }
  },
  mounted: function mounted() {
    console.log('Loading training modules');
    this.getLessons();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10caacef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Training/list/index.vue
var Training_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.list},[_c('button',{staticClass:"btn sm",on:{"click":function($event){_vm.getLessons()}}},[_vm._v("Refresh List")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],class:_vm.$style.search,attrs:{"type":"search","placeholder":"Search"},domProps:{"value":(_vm.query)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.query=$event.target.value},function($event){_vm.search(_vm.query)}]}}),_vm._v(" "),(_vm.query)?_c('ul',_vm._l((_vm.results),function(item,index){return _c('li',{class:( _obj = {}, _obj[_vm.$style.category] = (item.type == 'category'), _obj ),on:{"click":function($event){_vm.selectItem(item.id)}}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.title))])])
var _obj;})):_vm._e(),_vm._v(" "),(!_vm.query)?_c('ul',_vm._l((_vm.items),function(item){return _c('list-item',{key:item.id,class:( _obj = {}, _obj[_vm.$style.category] = (item.type == 'category'), _obj ),attrs:{"training":item}})
var _obj;})):_vm._e()])}
var Training_list_staticRenderFns = []
var Training_list_esExports = { render: Training_list_render, staticRenderFns: Training_list_staticRenderFns }
/* harmony default export */ var components_Training_list = (Training_list_esExports);
// CONCATENATED MODULE: ./src/components/Training/list/index.vue
function Training_list_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("l3K8")
}
var Training_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Training_list___vue_template_functional__ = false
/* styles */
var Training_list___vue_styles__ = Training_list_injectStyle
/* scopeId */
var Training_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Training_list___vue_module_identifier__ = null
var Training_list_Component = Training_list_normalizeComponent(
  Training_list,
  components_Training_list,
  Training_list___vue_template_functional__,
  Training_list___vue_styles__,
  Training_list___vue_scopeId__,
  Training_list___vue_module_identifier__
)

/* harmony default export */ var src_components_Training_list = (Training_list_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var vue_select = __webpack_require__("T1ft");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// EXTERNAL MODULE: ./node_modules/lodash/set.js
var lodash_set = __webpack_require__("4yG7");
var set_default = /*#__PURE__*/__webpack_require__.n(lodash_set);

// CONCATENATED MODULE: ./src/api/product.js




/**
 * Get list of all available promo codes
 * @returns {promise}
 */
function product_list() {
  return auth.getAuthToken().then(function (token) {
    return axios_default.a.get(config.API_BASE_URL + '/admin/product/list', {
      params: { authToken: token }
    }).then(function (res) {
      return res.data;
    });
  });
}

/* harmony default export */ var product = ({
  list: product_list
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Training/edit/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var Training_edit = ({
  name: 'edit',
  components: {
    vSelect: vue_select_default.a,
    uiInput: lib_Form_Input
  },
  data: function data() {
    return {
      selected: {},
      type: '',
      category: '',
      product: '',
      tags: [],
      productOptions: [],
      videoType: '',
      typeOptions: [{ label: 'Lesson', value: 'module' }, { label: 'Folder', value: 'category' }],
      videoTypeOptions: [{ label: 'Youtube', value: 'youtube' }, { label: 'Wistia', value: 'wistia' }]
    };
  },

  watch: {
    $route: function $route(to, from) {
      if (to.params.id) {
        var vc = this;
        database.getSingle(['academy', 'lessons', to.params.id]).then(function (data) {
          vc.selected = data;
        });
      }
    },
    selected: function selected(newVal) {
      if (newVal) {
        this.type = find_default()(this.typeOptions, { value: this.selected.type });
        this.videoType = find_default()(this.videoTypeOptions, { value: this.selected.videoType });
        this.category = find_default()(this.getCategories(), { value: this.selected.category });
        this.tags = Array.isArray(newVal.tags) ? newVal.tags.join(', ') : null;
        this.product = find_default()(this.productOptions, { value: this.selected.product });
      }
    },
    type: function type(newVal) {
      if (newVal) {
        console.log('type changed', newVal);
        this.selected.type = newVal.value;
      }
    },
    videoType: function videoType(newVal) {
      if (newVal) {
        this.selected.videoType = newVal.value;
      }
    },
    category: function category(newVal) {
      if (newVal) {
        console.log('category changed', newVal);
        this.selected.category = newVal.value;
      }
    },
    product: function product(newVal) {
      if (newVal) {
        this.selected.product = newVal.value;
      }
    },
    tags: function tags(newVal) {
      if (newVal) {
        console.log('tags changed', newVal);
        var tagArray = [];
        each_default()(newVal.split(','), function (tag) {
          tagArray.push(tag.trim());
        });
        this.selected.tags = tagArray;
      } else {
        this.selected.tags = null;
      }
    }
  },
  methods: {
    save: function save() {
      if (this.selected.id) {
        console.log('Save', this.selected.id);
        var vc = this;
        database.update(['academy', 'lessons', this.selected.id], this.selected).then(function () {
          vc.$toasted.show('Changes were Saved', {
            duration: 3000,
            className: 'toasty'
          });
          vc.selected = {};
        }).catch(function (err) {
          this.$toasted.show('Error: ' + err, {
            duration: 3000,
            className: 'toasty'
          });
        });
      } else {
        this.$toasted.show('Nothing Saved! Fields are empty...', {
          duration: 3000,
          className: 'toasty'
        });
      }
    },
    saveAsNew: function saveAsNew() {
      if (this.selected.title && this.selected.img) {
        if (confirm('Are you sure you want to create a new record?')) {
          var now = new Date().getTime();
          var id = '_' + now + Math.floor(Math.random() * 1000);
          var newLesson = this.selected;
          newLesson.id = id;
          console.log('saving to new', id);
          var vc = this;
          database.update(['academy', 'lessons', id], newLesson).then(function () {
            vc.$store.commit(constants.NEW_LESSON, newLesson);
            vc.$toasted.show('Your new record has been created', {
              duration: 3000,
              className: 'toasty'
            });
            vc.selected = {};
          });
        }
      }
    },
    deleteItem: function deleteItem() {
      var vc = this;
      database.set(['academy', 'lessons', this.selected.id], null).then(function () {
        vc.$toasted.show('Record has been deleted', {
          duration: 3000,
          className: 'toasty'
        });
        vc.selected = {};
      });
    },
    newResource: function newResource() {
      var newIndex = '_' + new Date().getTime() + Math.floor(Math.random() * 1000);
      if (this.selected.items) {
        vue_esm["a" /* default */].set(this.selected.items, newIndex, {
          title: '',
          url: '',
          icon: 'fa-file-pdf-o'
        });
      } else {
        vue_esm["a" /* default */].set(this.selected, 'items', set_default()({}, newIndex, {
          title: '',
          url: '',
          icon: 'fa-file-pdf-o'
        }));
      }
    },
    removeResource: function removeResource(id) {
      console.log('delete', id);
      vue_esm["a" /* default */].delete(this.selected.items, id);
      this.$toasted.show('Resource has been removed', {
        duration: 3000,
        className: 'toasty'
      });
    },
    getCategories: function getCategories() {
      var data = this.$store.state.training.lessonsSrc;
      var list = map_default()(filter_default()(data, function (i) {
        return i.type === 'category';
      }), function (i) {
        return { label: i.title, value: i.id };
      });
      list.unshift({ label: 'TOP LEVEL', value: 'academy' });
      return list;
    }
  },
  mounted: function mounted() {
    var vc = this;
    // get list of available products
    product.list().then(function (products) {
      vc.productOptions = products.map(function (item) {
        return { label: item, value: item };
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-710bffd3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Training/edit/index.vue
var Training_edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.edit},[_c('div',{class:_vm.$style.topRight},[(_vm.selected.title)?_c('button',{staticClass:"btn mini",on:{"click":function($event){_vm.deleteItem()}}},[_vm._v("Delete")]):_vm._e()]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.save($event)}}},[_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('ui-input',{model:{value:(_vm.selected.title),callback:function ($$v) {_vm.$set(_vm.selected, "title", $$v)},expression:"selected.title"}})],1),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"slug"}},[_vm._v("Sub-Title")]),_vm._v(" "),_c('ui-input',{model:{value:(_vm.selected.subtitle),callback:function ($$v) {_vm.$set(_vm.selected, "subtitle", $$v)},expression:"selected.subtitle"}})],1),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"tag"}},[_vm._v("Tags (seperated by comma)")]),_vm._v(" "),_c('ui-input',{model:{value:(_vm.tags),callback:function ($$v) {_vm.tags=$$v},expression:"tags"}})],1),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"label"}},[_vm._v("Long Description (displays underneath the title)")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.intro),expression:"selected.intro"}],attrs:{"rows":"4"},domProps:{"value":(_vm.selected.intro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selected, "intro", $event.target.value)}}})]),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"image"}},[_vm._v("Thumbnail Image URL")]),_vm._v(" "),_c('ui-input',{model:{value:(_vm.selected.img),callback:function ($$v) {_vm.$set(_vm.selected, "img", $$v)},expression:"selected.img"}}),_vm._v(" "),_c('div',{class:_vm.$style.thumb},[_c('img',{attrs:{"src":_vm.selected.img}})])],1),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"video"}},[_vm._v("Video ID")]),_vm._v(" "),_c('ui-input',{model:{value:(_vm.selected.video),callback:function ($$v) {_vm.$set(_vm.selected, "video", $$v)},expression:"selected.video"}})],1),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"type"}},[_vm._v("Video Source")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.videoTypeOptions},model:{value:(_vm.videoType),callback:function ($$v) {_vm.videoType=$$v},expression:"videoType"}})],1),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"index"}},[_vm._v("Index (used for sorting)")]),_vm._v(" "),_c('ui-input',{model:{value:(_vm.selected.index),callback:function ($$v) {_vm.$set(_vm.selected, "index", $$v)},expression:"selected.index"}})],1),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"type"}},[_vm._v("Type")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.typeOptions},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"category"}},[_vm._v("Parent Category")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.getCategories()},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})],1),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('label',{attrs:{"for":"type"}},[_vm._v("Product")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.productOptions},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}})],1),_vm._v(" "),_c('div',{class:_vm.$style.resources},[_c('h3',[_vm._v("Resource Items "),_c('div',{staticClass:"btn sm",on:{"click":function($event){_vm.newResource()}}},[_vm._v("Add New")])]),_vm._v(" "),_vm._l((_vm.selected.items),function(item,index){return _c('div',{class:_vm.$style.items},[_c('div',{class:_vm.$style.resourceItem},[_c('div',{class:_vm.$style.delete,on:{"click":function($event){_vm.removeResource(index)}}},[_vm._v(" X ")]),_vm._v("\n          title:\n          "),_c('ui-input',{model:{value:(item.title),callback:function ($$v) {_vm.$set(item, "title", $$v)},expression:"item.title"}}),_vm._v("\n          url:\n          "),_c('ui-input',{model:{value:(item.url),callback:function ($$v) {_vm.$set(item, "url", $$v)},expression:"item.url"}})],1)])})],2),_vm._v(" "),_c('div',{class:_vm.$style.formControl},[_c('button',{staticClass:"btn",attrs:{"type":"submit"}},[_vm._v("Save All Changes")]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){_vm.saveAsNew()}}},[_vm._v("Save As New")])])])])}
var Training_edit_staticRenderFns = []
var Training_edit_esExports = { render: Training_edit_render, staticRenderFns: Training_edit_staticRenderFns }
/* harmony default export */ var components_Training_edit = (Training_edit_esExports);
// CONCATENATED MODULE: ./src/components/Training/edit/index.vue
function Training_edit_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("X7PH")
}
var Training_edit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Training_edit___vue_template_functional__ = false
/* styles */
var Training_edit___vue_styles__ = Training_edit_injectStyle
/* scopeId */
var Training_edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Training_edit___vue_module_identifier__ = null
var Training_edit_Component = Training_edit_normalizeComponent(
  Training_edit,
  components_Training_edit,
  Training_edit___vue_template_functional__,
  Training_edit___vue_styles__,
  Training_edit___vue_scopeId__,
  Training_edit___vue_module_identifier__
)

/* harmony default export */ var src_components_Training_edit = (Training_edit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Training/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Training = ({
  name: 'training',
  components: {
    Header: components_lib_Header,
    list: src_components_Training_list,
    edit: src_components_Training_edit
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a999c882","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Training/index.vue
var Training_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.training}},[_c('Header'),_vm._v(" "),_c('div',{class:_vm.$style.body},[_c('div',{class:[_vm.$style.block]},[_c('h1',[_vm._v("Edit Training Modules")]),_vm._v(" "),_c('p',[_vm._v("Select an item on the right that you would like to edit.")]),_vm._v(" "),_c('edit')],1),_vm._v(" "),_c('div',{class:[_vm.$style.block, _vm.$style.short]},[_c('list')],1)])],1)}
var Training_staticRenderFns = []
var Training_esExports = { render: Training_render, staticRenderFns: Training_staticRenderFns }
/* harmony default export */ var components_Training = (Training_esExports);
// CONCATENATED MODULE: ./src/components/Training/index.vue
function Training_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("cv7/")
}
var Training_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Training___vue_template_functional__ = false
/* styles */
var Training___vue_styles__ = Training_injectStyle
/* scopeId */
var Training___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Training___vue_module_identifier__ = null
var Training_Component = Training_normalizeComponent(
  Training,
  components_Training,
  Training___vue_template_functional__,
  Training___vue_styles__,
  Training___vue_scopeId__,
  Training___vue_module_identifier__
)

/* harmony default export */ var src_components_Training = (Training_Component.exports);

// CONCATENATED MODULE: ./src/components/Count/confetti.js
/**
 * Build and run the confetti animation
 * @param {object} canvas element ref
 * @param {number} duration in seconds to display
 * @param {boolean} clickable explode on click
 */
function initialize(canvas, duration, clickable) {
  var ctx = canvas.getContext('2d');
  var startTime = new Date().getTime();
  var currentTime = startTime;
  var width = void 0,
      height = void 0;

  var items = [];
  var colors = ['#0095f7', '#ffffff', '#7579FF', '#ffffff', '#0095f7', '#7579FF', '#ffffff', '#0095f7'];
  var index = 150;
  var started = Date.now();

  function resize() {
    width = canvas.width = window.innerWidth;
    height = canvas.height = window.innerHeight;
  }

  function particle(x, y, i, minv) {
    var angle = Math.random() * (Math.PI * 2);
    var amount = Math.random() * 15.0 + minv;
    var vx = Math.sin(angle) * amount;
    var vy = Math.cos(angle) * amount;

    return {
      x: x,
      y: y,
      vx: vx,
      vy: vy,
      width: Math.random() * 15 + 8,
      height: Math.random() * 20 + 8,
      color: colors[i % colors.length],
      circle: Math.random() > 0.8,
      rotate: Math.random() * 180,
      direction: Math.random() * 5 - 2.5,
      fallSpeed: Math.random() / 10 + 0.1
    };
  }

  function render() {
    ctx.clearRect(0, 0, width, height);
    var time = new Date().getTime();
    var delta = (time - currentTime) / (1000 / 60);
    currentTime = time;

    if (time - startTime > 1500 && (!duration || Date.now() < started + duration * 1000)) {
      items[++index % 600] = particle(Math.random() * width, -20, index, 10);
    }

    items.forEach(function (item) {
      item.vx *= 1.0 - 0.05 * delta;
      item.vy += delta * item.fallSpeed;
      item.vy /= 1.0 + 0.05 * delta;
      item.x += delta * item.vx;
      item.y += delta * item.vy;
      item.rotate += delta * item.direction;

      ctx.fillStyle = item.color;
      if (item.circle) {
        ctx.beginPath();
        ctx.arc(item.x, item.y, item.width / 2, 0, 2 * Math.PI);
        ctx.fill();
        ctx.closePath();
      } else {
        ctx.save();
        ctx.beginPath();
        ctx.translate(item.x, item.y);
        ctx.rotate(item.rotate * Math.PI / 180);
        ctx.fillRect(-item.width / 2, -item.height / 2, item.width, item.height);
        ctx.translate(-item.x, -item.y);
        ctx.restore();
        ctx.closePath();
      }
    });

    window.requestAnimationFrame(render);
  }

  resize();
  for (var i = 0; i < index; i++) {
    items[i] = particle(width / 2, height / 2, i, 10);
  }

  if (clickable) {
    window.onclick = function (e) {
      for (var _i = 0; _i < 150; _i++) {
        items[(index + 150 + _i) % 600] = particle(e.clientX, e.clientY, _i, 10);
      }
      index = (index + 150) % 600;
    };
  }

  window.ontouchstart = function (e) {
    for (var d = 0; d < e.changedTouches.length; d++) {
      for (var _i2 = 0; _i2 < 150; _i2++) {
        items[(index + 150 + _i2) % 600] = particle(e.changedTouches[d].pageX, e.changedTouches[d].pageY, _i2, 10);
      }
      index = (index + 150) % 600;
    }
  };

  window.onresize = resize;
  render();
}

/* harmony default export */ var confetti = ({
  initialize: initialize
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Count/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var Count_firebase = window.firebase;
/* harmony default export */ var Count = ({
  name: 'count',
  data: function data() {
    return {
      count: 0
    };
  },

  methods: {
    formatNum: function formatNum(x) {
      if (!x) return '0';
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  },
  mounted: function mounted() {
    var _this = this;

    // bind to firebase endpoint to get count from server
    Count_firebase.database().ref('btnCount/count').on('value', function (snap) {
      _this.count = snap.val();
    });

    // listen for keypress to update count instantly
    document.onkeypress = function (e) {
      if (e.key === 'i') {
        _this.count++;
      }
    };
  },

  watch: {
    count: function count() {
      if (Math.floor(Math.random() * 20) === 0) {
        confetti.initialize(this.$refs.confetti, 5);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-475f8ac1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Count/index.vue
var Count_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"statement",staticStyle:{"text-align":"center"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.formatNum(_vm.count)))]),_vm._v(" "),_c('div',[_vm._v("Times")]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('canvas',{ref:"confetti",staticClass:"confetti"})])}
var Count_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("We've Recommitted"),_c('br'),_vm._v("To Our Customers")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"https://useproof.s3.amazonaws.com/turbo1/logo-primary.svg","height":"50"}})])}]
var Count_esExports = { render: Count_render, staticRenderFns: Count_staticRenderFns }
/* harmony default export */ var components_Count = (Count_esExports);
// CONCATENATED MODULE: ./src/components/Count/index.vue
function Count_injectStyle (ssrContext) {
  __webpack_require__("Vul5")
}
var Count_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Count___vue_template_functional__ = false
/* styles */
var Count___vue_styles__ = Count_injectStyle
/* scopeId */
var Count___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Count___vue_module_identifier__ = null
var Count_Component = Count_normalizeComponent(
  Count,
  components_Count,
  Count___vue_template_functional__,
  Count___vue_styles__,
  Count___vue_scopeId__,
  Count___vue_module_identifier__
)

/* harmony default export */ var src_components_Count = (Count_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TeamDashboard/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var TeamDashboard = ({
  name: 'TeamDashboard',
  components: {
    Header: components_lib_Header
  },
  data: function data() {
    return {
      splitTests: 13337,
      mergeRequests: []
    };
  },

  methods: {
    time: function time(ts) {
      return moment_default()(ts).fromNow();
    }
  },
  mounted: function mounted() {
    var _this = this;

    database.bindOrder(['team', 'mergeRequests'], 'timestamp', 10, function (snap) {
      var vals = values_default()(snap.val());
      _this.mergeRequests = vals.sort(function (a, b) {
        return a.timestamp < b.timestamp;
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e2e6c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamDashboard/index.vue
var TeamDashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("New Releases")]),_vm._v(" "),_c('div',{class:_vm.$style.block},_vm._l((_vm.mergeRequests),function(mr,index){return _c('div',{key:index,class:_vm.$style.listItem},[(!mr.projectImage)?_c('div',{class:_vm.$style.icon}):_vm._e(),_vm._v(" "),(mr.projectImage)?_c('img',{class:_vm.$style.iconNoBg,attrs:{"src":mr.projectImage}}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.$style.text},[_c('div',{class:_vm.$style.underline},[_c('h3',{class:_vm.$style.projectName},[_vm._v(_vm._s(mr.projectName))])]),_vm._v(" "),_c('div',{class:_vm.$style.timestamp},[_vm._v(_vm._s(_vm.time(mr.timestamp)))]),_vm._v(" "),_c('div',{class:_vm.$style.title},[_vm._v(_vm._s(mr.title))]),_vm._v(" "),_c('div',{class:_vm.$style.desc},[_vm._v(_vm._s(mr.desc))])])])}))])}
var TeamDashboard_staticRenderFns = []
var TeamDashboard_esExports = { render: TeamDashboard_render, staticRenderFns: TeamDashboard_staticRenderFns }
/* harmony default export */ var components_TeamDashboard = (TeamDashboard_esExports);
// CONCATENATED MODULE: ./src/components/TeamDashboard/index.vue
function TeamDashboard_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("53YY")
}
var TeamDashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TeamDashboard___vue_template_functional__ = false
/* styles */
var TeamDashboard___vue_styles__ = TeamDashboard_injectStyle
/* scopeId */
var TeamDashboard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TeamDashboard___vue_module_identifier__ = null
var TeamDashboard_Component = TeamDashboard_normalizeComponent(
  TeamDashboard,
  components_TeamDashboard,
  TeamDashboard___vue_template_functional__,
  TeamDashboard___vue_styles__,
  TeamDashboard___vue_scopeId__,
  TeamDashboard___vue_module_identifier__
)

/* harmony default export */ var src_components_TeamDashboard = (TeamDashboard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PixelTest/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PixelTest = ({
  name: 'PixelTest',
  components: {
    Header: components_lib_Header
  },
  data: function data() {
    return {
      url: ''
    };
  },

  methods: {
    goToView: function goToView() {
      // this.$router.push({path: 'view-test', query: {u: this.url}})
      window.location = '/view-test?u=' + this.url;
    },
    confirmConversion: function confirmConversion() {
      this.$toasted.show('Added Conversion', {
        duration: 3000,
        className: 'toasty'
      });
    }
  },
  mounted: function mounted() {
    var pixel = document.createElement('script');
    pixel.setAttribute('src', 'https://cdn-staging.useproof.com/proof.js?acc=FaqmdDysP5MwCwmVmJ6DewyAKtm2');
    document.head.appendChild(pixel);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33068da7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PixelTest/index.vue
var PixelTest_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_c('h1',[_vm._v("Pixel Test")]),_vm._v(" "),_c('div',{class:_vm.$style.body},[_c('div',{class:_vm.$style.block},[_c('p',[_vm._v("Preview Proof notifications on a given website.")]),_vm._v(" "),_c('p'),_c('h3',[_vm._v("Site to preview")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.goToView($event)}}},[_vm._v("\n          URL: "),_c('i',[_vm._v("https://")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.url),expression:"url"}],domProps:{"value":(_vm.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value}}}),_vm._v(" "),_c('button',{attrs:{"type":"submit"},on:{"click":_vm.goToView}},[_vm._v("Go To Preview")])]),_vm._v(" "),_c('p',{class:_vm.$style.note},[_vm._v("*will not work on sites with "),_c('code',[_vm._v("X-Frame-Options': 'sameorigin'")])]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('h3',[_vm._v("Submit a new conversion to display")]),_vm._v(" "),_c('div',[_c('input'),_vm._v(" "),_c('button',{on:{"click":_vm.confirmConversion}},[_vm._v("Submit")])]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',{class:_vm.$style.note},[_vm._v("*To manage this campaign, log in to staging app as:"),_c('br'),_vm._v(" user: "),_c('code',[_vm._v("marketing@useproof.com")]),_c('br'),_vm._v(" pass: "),_c('code',[_vm._v("password")])])])])],1)}
var PixelTest_staticRenderFns = []
var PixelTest_esExports = { render: PixelTest_render, staticRenderFns: PixelTest_staticRenderFns }
/* harmony default export */ var components_PixelTest = (PixelTest_esExports);
// CONCATENATED MODULE: ./src/components/PixelTest/index.vue
function PixelTest_injectStyle (ssrContext) {
  __webpack_require__("t/dT")
  this["$style"] = __webpack_require__("2sGt")
}
var PixelTest_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PixelTest___vue_template_functional__ = false
/* styles */
var PixelTest___vue_styles__ = PixelTest_injectStyle
/* scopeId */
var PixelTest___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PixelTest___vue_module_identifier__ = null
var PixelTest_Component = PixelTest_normalizeComponent(
  PixelTest,
  components_PixelTest,
  PixelTest___vue_template_functional__,
  PixelTest___vue_styles__,
  PixelTest___vue_scopeId__,
  PixelTest___vue_module_identifier__
)

/* harmony default export */ var src_components_PixelTest = (PixelTest_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PixelTest/ViewTest.vue
//
//
//
//
//

/* harmony default export */ var ViewTest = ({
  name: 'ViewTest',
  mounted: function mounted() {
    var pixel = document.createElement('script');
    pixel.setAttribute('src', 'https://cdn-staging.useproof.com/proof.js?acc=FaqmdDysP5MwCwmVmJ6DewyAKtm2');
    document.body.appendChild(pixel);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ce5aec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PixelTest/ViewTest.vue
var ViewTest_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"src":("https://" + (_vm.$route.query.u))}})])}
var ViewTest_staticRenderFns = []
var ViewTest_esExports = { render: ViewTest_render, staticRenderFns: ViewTest_staticRenderFns }
/* harmony default export */ var PixelTest_ViewTest = (ViewTest_esExports);
// CONCATENATED MODULE: ./src/components/PixelTest/ViewTest.vue
function ViewTest_injectStyle (ssrContext) {
  __webpack_require__("Z96H")
}
var ViewTest_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ViewTest___vue_template_functional__ = false
/* styles */
var ViewTest___vue_styles__ = ViewTest_injectStyle
/* scopeId */
var ViewTest___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ViewTest___vue_module_identifier__ = null
var ViewTest_Component = ViewTest_normalizeComponent(
  ViewTest,
  PixelTest_ViewTest,
  ViewTest___vue_template_functional__,
  ViewTest___vue_styles__,
  ViewTest___vue_scopeId__,
  ViewTest___vue_module_identifier__
)

/* harmony default export */ var components_PixelTest_ViewTest = (ViewTest_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__("HN2V");
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Promos/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var Promos_firebase = window.firebase;

function initAttrs() {
  return {
    products: [],
    accountUpdates: {
      visitorLimitModifier: null,
      visitorLimitModifierType: null,
      resetOnPlanChange: null
    },
    billing: {
      customerCouponCode: null,
      trialPeriod: null
    },
    frontendMessaging: {
      hidePromo: null,
      planType: null,
      register: {
        subheadline: null
      },
      plans: {
        subheadline: null
      },
      payment: {
        subheadline: null,
        benefits: [],
        button: null,
        loadingMsg: null
      }
    }
  };
}

/* harmony default export */ var Promos = ({
  name: 'Promos',
  components: {
    Header: components_lib_Header
  },
  data: function data() {
    var _modifierTypeOptions;

    return {
      id: null,
      attrs: initAttrs(),
      promoList: {},
      newPromoName: null,
      productOptions: {
        FBADS: 'FBADS',
        WEBINAR_BOOTCAMP: 'WEBINAR_BOOTCAMP',
        SIX_K_SUCCESS: 'SIX_K_SUCCESS',
        HIGH_TICKET_MASTERY: 'HIGH_TICKET_MASTERY',
        SHARE_FUNNELS: 'SHARE_FUNNELS',
        CONVERSION_SECRETS: 'CONVERSION_SECRETS',
        EA: 'EA'
      },
      modifierTypeOptions: (_modifierTypeOptions = {}, defineProperty_default()(_modifierTypeOptions, null, null), defineProperty_default()(_modifierTypeOptions, 'multiply', 'multiply'), defineProperty_default()(_modifierTypeOptions, 'add', 'add'), defineProperty_default()(_modifierTypeOptions, 'limit', 'limit'), _modifierTypeOptions)
    };
  },

  methods: {
    loadPromo: function loadPromo(id) {
      this.id = this.$route.params.id;
      if (this.promoList[this.id]) {
        this.attrs = merge_default()(initAttrs(), this.promoList[this.id]);
      } else {
        this.attrs = initAttrs();
      }
    },
    savePromo: function savePromo() {
      var _this = this;

      if (confirm('Save this promo code?')) {
        Promos_firebase.database().ref('promos').child(this.id).set(this.attrs).then(function () {
          _this.$toasted.show('Promo code saved', {
            duration: 3000,
            className: 'toasty'
          });
        }).catch(function () {
          _this.$toasted.show('Unable to save promo code', {
            duration: 3000,
            className: 'toasty-error'
          });
        });
      }
    },
    removePromo: function removePromo() {
      if (this.id && confirm('Remove this promo code?')) {
        Promos_firebase.database().ref('promos').child(this.id).remove();
      }
    },
    newPromo: function newPromo() {
      this.$router.push({ name: 'EditPromo', params: { id: this.newPromoName } });
    }
  },
  created: function created() {
    var _this2 = this;

    Promos_firebase.database().ref('promos').on('value', function (snap) {
      _this2.promoList = snap.val();

      if (_this2.$route.params.id) {
        _this2.loadPromo(_this2.$route.params.id);
      }
    });
  },

  watch: {
    $route: function $route(to, from) {
      if (to.params.id) {
        this.loadPromo(to.params.id);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02169710","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Promos/index.vue
var Promos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.promos}},[_c('Header'),_vm._v(" "),_c('div',{class:_vm.$style.body},[_c('div',{class:[_vm.$style.block]},[_c('h1',[_vm._v("Edit Promo Codes")]),_vm._v(" "),_c('p',[_vm._v("Select an item on the right that you would like to edit.")]),_vm._v(" "),(_vm.id)?_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.savePromo($event)}}},[_c('div',{class:_vm.$style.field},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.id),expression:"id"}],attrs:{"type":"text"},domProps:{"value":(_vm.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.id=$event.target.value}}})]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("Products")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.products),expression:"attrs.products"}],class:_vm.$style.products,attrs:{"multiple":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.attrs, "products", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.productOptions),function(product){return _c('option',{key:product,domProps:{"value":product}},[_vm._v(_vm._s(product))])}))]),_vm._v(" "),_c('h3',[_vm._v("Override Visitor Limits")]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("Modifier (amount)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.accountUpdates.visitorLimitModifier),expression:"attrs.accountUpdates.visitorLimitModifier"}],attrs:{"type":"text"},domProps:{"value":(_vm.attrs.accountUpdates.visitorLimitModifier)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.attrs.accountUpdates, "visitorLimitModifier", $event.target.value)}}})]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.accountUpdates.visitorLimitModifierType),expression:"attrs.accountUpdates.visitorLimitModifierType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.attrs.accountUpdates, "visitorLimitModifierType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.modifierTypeOptions),function(option){return _c('option',{key:option},[_vm._v(_vm._s(option))])}))]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.accountUpdates.resetOnPlanChange),expression:"attrs.accountUpdates.resetOnPlanChange"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.attrs.accountUpdates.resetOnPlanChange)?_vm._i(_vm.attrs.accountUpdates.resetOnPlanChange,null)>-1:(_vm.attrs.accountUpdates.resetOnPlanChange)},on:{"change":function($event){var $$a=_vm.attrs.accountUpdates.resetOnPlanChange,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.attrs.accountUpdates.resetOnPlanChange=$$a.concat([$$v]))}else{$$i>-1&&(_vm.attrs.accountUpdates.resetOnPlanChange=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.attrs.accountUpdates, "resetOnPlanChange", $$c)}}}}),_vm._v("Reset on plan change")]),_vm._v(" "),_c('h3',[_vm._v("Billing")]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("Stripe Coupon Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.billing.customerCouponCode),expression:"attrs.billing.customerCouponCode"}],attrs:{"type":"text"},domProps:{"value":(_vm.attrs.billing.customerCouponCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.attrs.billing, "customerCouponCode", $event.target.value)}}})]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("Trial Period (days)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.billing.trialPeriod),expression:"attrs.billing.trialPeriod"}],attrs:{"type":"number"},domProps:{"value":(_vm.attrs.billing.trialPeriod)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.attrs.billing, "trialPeriod", $event.target.value)}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Override Front End Messaging")]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("Only allow on specific plan type")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.frontendMessaging.planType),expression:"attrs.frontendMessaging.planType"}],attrs:{"type":"text"},domProps:{"value":(_vm.attrs.frontendMessaging.planType)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.attrs.frontendMessaging, "planType", $event.target.value)}}}),_vm._v(" "),_c('div',{class:_vm.$style.note},[_vm._v("'annual' or 'monthly'")])]),_vm._v(" "),_c('h3',[_vm._v("Register Page")]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',{class:_vm.$style.field},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.frontendMessaging.hidePromo),expression:"attrs.frontendMessaging.hidePromo"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.attrs.frontendMessaging.hidePromo)?_vm._i(_vm.attrs.frontendMessaging.hidePromo,null)>-1:(_vm.attrs.frontendMessaging.hidePromo)},on:{"change":function($event){var $$a=_vm.attrs.frontendMessaging.hidePromo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.attrs.frontendMessaging.hidePromo=$$a.concat([$$v]))}else{$$i>-1&&(_vm.attrs.frontendMessaging.hidePromo=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.attrs.frontendMessaging, "hidePromo", $$c)}}}}),_vm._v(" Do not display promo code")])]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("Subheadline")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.frontendMessaging.register.subheadline),expression:"attrs.frontendMessaging.register.subheadline"}],attrs:{"type":"text"},domProps:{"value":(_vm.attrs.frontendMessaging.register.subheadline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.attrs.frontendMessaging.register, "subheadline", $event.target.value)}}})]),_vm._v(" "),_c('h3',[_vm._v("Plans Page")]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("Subheadline")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.frontendMessaging.plans.subheadline),expression:"attrs.frontendMessaging.plans.subheadline"}],attrs:{"type":"text"},domProps:{"value":(_vm.attrs.frontendMessaging.plans.subheadline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.attrs.frontendMessaging.plans, "subheadline", $event.target.value)}}})]),_vm._v(" "),_c('h3',[_vm._v("Payment Page")]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("Subheadline")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.frontendMessaging.payment.subheadline),expression:"attrs.frontendMessaging.payment.subheadline"}],attrs:{"type":"text"},domProps:{"value":(_vm.attrs.frontendMessaging.payment.subheadline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.attrs.frontendMessaging.payment, "subheadline", $event.target.value)}}})]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("Button Text")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.frontendMessaging.payment.button),expression:"attrs.frontendMessaging.payment.button"}],attrs:{"type":"text"},domProps:{"value":(_vm.attrs.frontendMessaging.payment.button)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.attrs.frontendMessaging.payment, "button", $event.target.value)}}})]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("Loading Message")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.frontendMessaging.payment.loadingMsg),expression:"attrs.frontendMessaging.payment.loadingMsg"}],attrs:{"type":"text"},domProps:{"value":(_vm.attrs.frontendMessaging.payment.loadingMsg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.attrs.frontendMessaging.payment, "loadingMsg", $event.target.value)}}})]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('div',[_vm._v("List of Benefits "),_c('button',{on:{"click":function($event){$event.preventDefault();_vm.attrs.frontendMessaging.payment.benefits.push('')}}},[_vm._v("Add")])]),_vm._v(" "),_vm._l((_vm.attrs.frontendMessaging.payment.benefits),function(benefit,index){return _c('div',{key:index},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attrs.frontendMessaging.payment.benefits[index]),expression:"attrs.frontendMessaging.payment.benefits[index]"}],attrs:{"type":"text"},domProps:{"value":(_vm.attrs.frontendMessaging.payment.benefits[index])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.attrs.frontendMessaging.payment.benefits, index, $event.target.value)}}}),_vm._v(" "),_c('span',{class:_vm.$style.xButton,on:{"click":function($event){_vm.attrs.frontendMessaging.payment.benefits.splice(index, 1)}}},[_vm._v("x")])])})],2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('button',{attrs:{"type":"sumbit"}},[_vm._v("Submit")])]),_vm._v(" "),_c('div',{class:_vm.$style.field},[_c('button',{on:{"click":function($event){$event.preventDefault();_vm.removePromo($event)}}},[_vm._v("Delete")])])]):_vm._e()]),_vm._v(" "),_c('div',{class:[_vm.$style.block, _vm.$style.short]},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPromoName),expression:"newPromoName"}],domProps:{"value":(_vm.newPromoName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPromoName=$event.target.value}}}),_c('button',{on:{"click":_vm.newPromo}},[_vm._v("New Promo")])]),_vm._v(" "),_c('ul',{class:_vm.$style.list},_vm._l((_vm.promoList),function(promo,id){return _c('li',{key:id},[_c('router-link',{class:_vm.$style.title,attrs:{"to":{ name: 'EditPromo', params: { id: id } }}},[_vm._v(_vm._s(id))])],1)}))])])],1)}
var Promos_staticRenderFns = []
var Promos_esExports = { render: Promos_render, staticRenderFns: Promos_staticRenderFns }
/* harmony default export */ var components_Promos = (Promos_esExports);
// CONCATENATED MODULE: ./src/components/Promos/index.vue
function Promos_injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("Wt3H")
}
var Promos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Promos___vue_template_functional__ = false
/* styles */
var Promos___vue_styles__ = Promos_injectStyle
/* scopeId */
var Promos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Promos___vue_module_identifier__ = null
var Promos_Component = Promos_normalizeComponent(
  Promos,
  components_Promos,
  Promos___vue_template_functional__,
  Promos___vue_styles__,
  Promos___vue_scopeId__,
  Promos___vue_module_identifier__
)

/* harmony default export */ var src_components_Promos = (Promos_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js













vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/login',
    name: 'Login',
    component: src_components_Login
  }, {
    path: '/',
    name: 'Overview',
    component: src_components_Overview,
    meta: { auth: true }
  }, {
    path: '/users',
    name: 'Users',
    component: src_components_Users,
    meta: { auth: true }
  }, {
    path: '/users/:id',
    name: 'Users',
    component: src_components_Users,
    meta: { auth: true }
  }, {
    path: '/training',
    name: 'Training',
    component: src_components_Training,
    meta: { auth: true }
  }, {
    path: '/promos',
    name: 'Promos',
    component: src_components_Promos,
    meta: { auth: true }
  }, {
    path: '/promos/:id',
    name: 'EditPromo',
    component: src_components_Promos,
    meta: { auth: true }
  }, {
    path: '/training/:id',
    name: 'Edit Lesson',
    component: src_components_Training,
    meta: { auth: true }
  }, {
    path: '/count',
    name: 'Count',
    component: src_components_Count
  }, {
    path: '/team-dashboard',
    name: 'Team Dashboard',
    component: src_components_TeamDashboard,
    meta: { auth: true }
  }, {
    path: '/pixel-test',
    name: 'Pixel Test',
    component: src_components_PixelTest,
    meta: { auth: true }
  }, {
    path: '/view-test',
    name: 'View Test',
    component: components_PixelTest_ViewTest,
    meta: { auth: true }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    // To simulate "scroll to anchor" behavior:
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 10 }
      };
    }
    // native-like scroll behavior when navigating with back/forward (scroll to saved position)
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// Handle Authenticated Routes
router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.auth;
  }) && !auth.isSignedIn()) {
    next({ path: '/login' });
  } else {
    next();
  }
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/auth/index.js





var auth_firebase = window.firebase;

/**
 * TODO: During the initial page load add an in between step that shows them
 * a loading component that handles the redirect to the login page or where
 * ever they intended to go.  That way the login page doesn't flash on every
 * full page load.
 */

/**
 * TODO: add a ?redirect= param to the login path and then redirect to that
 * page when authentication happens.
 */

/**
 * Watch for changes in Auth state and redirect to login if not authenticated
 */
function watchAuthState() {
  auth_firebase.auth().onAuthStateChanged(function (user) {
    var requiresAuth = src_router.currentRoute.meta.auth;
    if (user) {
      auth_firebase.database().ref('admins').child(user.uid).child('active').once('value').then(function (snap) {
        if (!snap.val()) {
          src_state.commit(constants.SIGN_OUT, 'User does not have required permissions');
          src_router.push({ path: '/login' });
        }
      });
    } else if (requiresAuth) {
      src_state.commit(constants.SIGN_OUT);
      src_router.push({ path: '/login' });
    }
  });
}

/**
 * Sign in with Google
 */
function signInWithGoogle() {
  var provider = new auth_firebase.auth.GoogleAuthProvider();
  return auth_firebase.auth().signInWithPopup(provider).then(function (result) {
    if (result.user) {
      src_state.commit(constants.SIGN_IN, {
        uid: result.user.uid
      });
      src_router.push('/');
      return result.user;
    }
  }).catch(function (error) {
    return error.message;
  });
}

/**
 * Sign out the current user
 */
function auth_signOut() {
  return auth_firebase.auth().signOut().catch(console.log);
}

/**
 * Check if the user is signed in
 */
function isSignedIn() {
  return src_state.state.signedIn;
}

/**
 * Get the auth token for the current user
 * @returns {promise}
 */
function getAuthToken() {
  // request a new token if > 30 minutes old
  if (src_state.state.authIdToken && new Date().getTime() - src_state.state.authIdTokenTimestamp < 30 * 30 * 1000) {
    return promise_default.a.resolve(src_state.state.authIdToken);
  } else {
    return auth_firebase.auth().currentUser.getIdToken(true).then(function (token) {
      src_state.commit(constants.SAVE_ID_TOKEN, token);
      return token;
    });
  }
}

/* harmony default export */ var auth = ({
  signInWithGoogle: signInWithGoogle,
  signOut: auth_signOut,
  isSignedIn: isSignedIn,
  getAuthToken: getAuthToken,
  watchAuthState: watchAuthState
});
// CONCATENATED MODULE: ./src/state/index.js


var _mutations;








vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var src_state = (new vuex_esm["a" /* default */].Store({
  state: {
    authIdToken: null,
    authIdTokenTimestamp: null,
    signedIn: false,
    signInFail: null,
    user: {},
    training: {
      lessons: [],
      lessonsSrc: []
    }
  },
  plugins: [Object(vuex_persistedstate_es["a" /* default */])({
    key: 'auth',
    paths: ['signedIn', 'authIdToken', 'authIdTokenTimestamp']
  })],
  mutations: (_mutations = {}, defineProperty_default()(_mutations, constants.SIGN_IN, function (state, payload) {
    state.signedIn = true;
    state.user = payload;
  }), defineProperty_default()(_mutations, constants.SIGN_OUT, function (state, payload) {
    if (payload) {
      state.signInFail = payload;
    }
    auth.signOut();
    state.signedIn = false;
  }), defineProperty_default()(_mutations, constants.SET_LESSONS, function (state, payload) {
    state.training.lessons = payload;
  }), defineProperty_default()(_mutations, constants.SET_LESSONS_SRC, function (state, payload) {
    state.training.lessonsSrc = payload;
  }), defineProperty_default()(_mutations, constants.NEW_LESSON, function (state, payload) {
    state.training.lessonsSrc.push(payload);
    state.training.lessons = lib.buildCatTree(state.training.lessonsSrc, 'academy');
  }), defineProperty_default()(_mutations, constants.SAVE_ID_TOKEN, function (state, payload) {
    state.authIdToken = payload;
    state.authIdTokenTimestamp = new Date().getTime();
  }), _mutations),
  actions: {}
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  store: src_state
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9605de46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("7/Ux")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-toasted/dist/vue-toasted.min.js
var vue_toasted_min = __webpack_require__("IZMb");
var vue_toasted_min_default = /*#__PURE__*/__webpack_require__.n(vue_toasted_min);

// EXTERNAL MODULE: ./node_modules/vue-instantsearch/dist/vue-instantsearch.esm.js
var vue_instantsearch_esm = __webpack_require__("MdZJ");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








database.openConnection();
auth.watchAuthState();

vue_esm["a" /* default */].config.productionTip = false;
vue_esm["a" /* default */].use(vue_toasted_min_default.a);
vue_esm["a" /* default */].use(vue_instantsearch_esm["a" /* default */]);

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "ODsN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"list":"_15CIpFK2iuwZDwZygdj1F8_0","search":"_2vLqbg71vgZ2HMLHhenqxr_0"};

/***/ }),

/***/ "OGIF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"section":"_2tMM1zl-sHbJzyi6nA6vuM_0","note":"_2n_DETZWuLVNsPT2QKMgHC_0","warn":"_3RArqYEE7Uj8q5xgQU2uWv_0"};

/***/ }),

/***/ "Vul5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wt3H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"promos":"_1HRFl-8B50EzRkOAJuywM0_0","body":"BxePPFWDUL1d-RkHg_tB_0","field":"hjxaZ-1u2DaVhi_mx3vFY_0","products":"_3FZRpu4dgRjYGeCKNcoNhx_0","note":"_3x_bWMsx47dKzOj_LON35Z_0","xButton":"_2SrSyWWVKypwlmaDK2wnte_0","block":"_1kkv-imiE9OtTNnRiN4pKv_0","short":"_nkF__ygCbom-NyRTowpT_0","list":"_2bDzqNMiw56MBMXlyDHcPy_0","title":"_1yafGFgsGNryHKWA3StZ6s_0"};

/***/ }),

/***/ "X7PH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"edit":"s9OgLfRxWP-Qn2DCfTKW2_0","topRight":"_1aKVpRgKu-gDJ0OdCdcq6_0","thumb":"_2KsynT1uC07npYaaHw0-b1_0","resourceItem":"GXOREew5TrazFk7jZVpQI_0","formControl":"_1zF25J2WnauD0pO4x5MT40_0","resources":"_39tzuQNooonYjbaJcc-j61_0","delete":"_2_R92-lcPNxdEVTS1AC9VH_0"};

/***/ }),

/***/ "XotS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overview":"_3jnkzZgBIUC8YblpZ7V-e__0","body":"_298kh8D1D6eDPzGPOQsk2A_0","block":"_2qmsaWfZ7DX5x6zwpuIdnh_0","short":"jTM15anB9rhhlkqesDatu_0"};

/***/ }),

/***/ "Z96H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cv7/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"training":"_3-pAIz8rg5C6kyCUtTTfDF_0","body":"_2PW8xGVsEz8DVn825t5Rb_0","block":"_3eY7l5hg_qZ6nGNMksSK_K_0","short":"_2RwjLzbTy8et8YA5ljxmve_0"};

/***/ }),

/***/ "fDhm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"_1-OsB_RKGOHDyFj6ig1LzW_0","darkBackground":"yQlIU6sA51xcZEkGZBRmS_0","main":"_1J0B9GpbR_gZuqwj8Tk0lB_0","brand":"_2GKpj5Ds5Zy8F7e7zTFCM6_0","center":"_1X4gM1vrllf1fkwUCWxR5W_0"};

/***/ }),

/***/ "l3K8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"list":"_3XyVIzoUaR9wCUni7VSIow_0","search":"_1lGiiXxajiQcI-0C2CN5Ob_0"};

/***/ }),

/***/ "msf9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"users":"_1icwzIeH7qUQsgHZxzWXWJ_0","body":"_1_R6MH0W4e98OhYM12xoLL_0","block":"_1JPLQI0dr20SJEV2tdDew6_0","short":"_186ZtPN81sBMmdcvzaS4Sl_0"};

/***/ }),

/***/ "ojnS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t/dT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wzrY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"input":"_1UGAku_JKiiMLog7OQ5I_o_0"};

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e53a17923d1e991c8ce9.js